import { DateTime } from "luxon";
import { Decimal } from "decimal.js";
const day2Millis = 86400 * 1000;
const millis2Day = 1 / day2Millis;
const mjd2000Unix = 946684800 * 1000;
export function mjd2unix(mjd) {
    return mjd * day2Millis + mjd2000Unix;
}
export function unix2mjd(unix) {
    return (unix - mjd2000Unix) * millis2Day;
}
export function mjd2mjd1950(mjd) {
    let diff = Decimal.add(mjd.toString(), "18262");
    return diff.toNumber();
}
export function mjd1950ToMjd2000(mjd1950) {
    let diff = Decimal.sub(mjd1950.toString(), "18262");
    return diff.toNumber();
}
export function mjd2jd(mjd) {
    let diff = Decimal.add(mjd.toString(), "2451544.5");
    return diff.toNumber();
}
export function jd2mjd2000(JD) {
    let diff = Decimal.sub(JD.toString(), "2451544.5");
    return diff.toNumber();
}
export function mjdtoYYYYDDD(mjd) {
    var dateTime = DateTime.fromMillis(mjd2unix(mjd)).toUTC();
    var yearPart = dateTime.toFormat("y");
    var decimals = (dateTime.toMillis() - new Date(yearPart).getTime()) * millis2Day;
    var finalDate = dateTime.toFormat("yooo") + "." + decimals.toString().split(".")[1];
    return parseFloat(finalDate);
}
export function dataYD2Mjd(dataYD) {
    var stringData = dataYD.toString();
    var dateTime;
    if (stringData.includes(".") && stringData.split(".")[0].length == 7) {
        var decimals = parseFloat("0." + stringData.split(".")[1]) * 24 * 60 * 60 * 1000;
        var intPart = stringData.split(".")[0];
        dateTime = DateTime.fromFormat(intPart, "yooo")
            .setZone("utc", { keepLocalTime: true })
            .plus({ milliseconds: decimals })
            .toMillis();
    }
    else {
        if (stringData.split(".")[0].length == 7) {
            dateTime = DateTime.fromFormat(stringData, "yooo")
                .setZone("utc", { keepLocalTime: true })
                .toUTC()
                .toMillis();
        }
        else {
            return undefined;
        }
    }
    return unix2mjd(dateTime);
}
export function mjd2GreenwichSA(mjd) {
    let greenwich = 99.96779469 + (360.9856474 + 2.90788e-13 * mjd) * mjd;
    return greenwich % 360;
}
export function iso86012focusString(iso8601) {
    return iso8601
        .replace(/-/g, "/")
        .replace("T", "-")
        .slice(0, -1);
}
export function dateToUTCString(date) {
    if (typeof date === "number") {
        const dateMillis = DateTime.fromMillis(date)
            .toUTC()
            .toString();
        return iso86012focusString(dateMillis);
    }
    if (typeof date === "string") {
        const dateString = DateTime.fromISO(date)
            .toUTC()
            .toString();
        return iso86012focusString(dateString);
    }
    return null;
}
export var ClockModes;
(function (ClockModes) {
    ClockModes["Default"] = "UTC";
    ClockModes["Local"] = "Local";
    ClockModes["GST"] = "GST";
})(ClockModes || (ClockModes = {}));
const defaultLeapsConfig = [
    { time: "2012-07-01T00:00:00Z", delta: 35 },
    { time: "2015-07-01T00:00:00Z", delta: 36 },
    { time: "2017-01-01T00:00:00Z", delta: 37 }
];
export const getTimeFromMode = (time, mode = ClockModes.Default, leapsConfig) => {
    let timeMode;
    if (mode) {
        switch (mode) {
            case "Local":
                timeMode = time.toLocal();
                break;
            case "GST":
                if (leapsConfig && leapsConfig.length > 0) {
                    timeMode = getGSTime(time, leapsConfig);
                }
                else {
                    timeMode = getGSTime(time, defaultLeapsConfig);
                }
                break;
            case "UTC":
            default:
                timeMode = time;
                break;
        }
    }
    else {
        timeMode = time;
    }
    return timeMode;
};
export const GetLeapSeconds = (time, timeLeaps) => {
    let delta;
    for (const leapItem of timeLeaps) {
        let referenceDate = DateTime.fromISO(leapItem.time);
        if (time > referenceDate) {
            delta = leapItem.delta;
        }
    }
    return delta - 19;
};
export const getGSTime = (time, timeLeaps) => {
    let leapSecond = GetLeapSeconds(time, timeLeaps);
    return time.plus({ seconds: leapSecond });
};
export const applyFormat = (time, format) => {
    if (format) {
        return time.toFormat(format);
    }
    return time.toFormat("dd LLL yyyy");
};
export const focusString2UTC = (date) => {
    const year = Number(date.toString().substring(0, 4));
    const month = Number(date.toString().substring(5, 7));
    const day = Number(date.toString().substring(8, 10));
    const hour = Number(date.toString().substring(11, 13));
    const minute = Number(date.toString().substring(14, 16));
    const second = Number(date.toString().substring(17, 19));
    return DateTime.utc(year, month, day, hour, minute, second);
};
export const getDayStartEnd = (date) => {
    const startDay = DateTime.utc(date.year, date.month, date.day, 0, 0, 0);
    const endDay = DateTime.utc(date.year, date.month, date.day, 23, 59, 59);
    return { startDay: startDay, endDay: endDay };
};
//# sourceMappingURL=timeParser.js.map